/**
 * Api Documentation
 * Api Documentation
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { IdDataLong } from '../model/idDataLong';
import { WatermarkData } from '../model/watermarkData';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class WatermarkService {

    protected basePath = 'https://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Create watermark
     * 
     * @param image Image
     * @param targetId Target
     * @param type Type
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createWatermark(image?: Blob, targetId?: string, type?: 'USER' | 'ORGANISATION' | 'SYSTEM', observe?: 'body', reportProgress?: boolean): Observable<IdDataLong>;
    public createWatermark(image?: Blob, targetId?: string, type?: 'USER' | 'ORGANISATION' | 'SYSTEM', observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IdDataLong>>;
    public createWatermark(image?: Blob, targetId?: string, type?: 'USER' | 'ORGANISATION' | 'SYSTEM', observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IdDataLong>>;
    public createWatermark(image?: Blob, targetId?: string, type?: 'USER' | 'ORGANISATION' | 'SYSTEM', observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (targetId !== undefined && targetId !== null) {
            queryParameters = queryParameters.set('targetId', <any>targetId);
        }
        if (type !== undefined && type !== null) {
            queryParameters = queryParameters.set('type', <any>type);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any; };
        let useForm = false;
        let convertFormParamsToString = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        }

        if (image !== undefined) {
            formParams = formParams.append('image', <any>image) || formParams;
        }

        return this.httpClient.post<IdDataLong>(`${this.basePath}/api/watermarks`,
            convertFormParamsToString ? formParams.toString() : formParams,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Delete watermark
     * 
     * @param watermarkId Watermark
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteWatermark(watermarkId: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public deleteWatermark(watermarkId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public deleteWatermark(watermarkId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public deleteWatermark(watermarkId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (watermarkId === null || watermarkId === undefined) {
            throw new Error('Required parameter watermarkId was null or undefined when calling deleteWatermark.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<any>(`${this.basePath}/api/watermarks/${encodeURIComponent(String(watermarkId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get watermark
     * 
     * @param watermarkId Watermark
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getWatermark(watermarkId: number, observe?: 'body', reportProgress?: boolean): Observable<WatermarkData>;
    public getWatermark(watermarkId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<WatermarkData>>;
    public getWatermark(watermarkId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<WatermarkData>>;
    public getWatermark(watermarkId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (watermarkId === null || watermarkId === undefined) {
            throw new Error('Required parameter watermarkId was null or undefined when calling getWatermark.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<WatermarkData>(`${this.basePath}/api/watermarks/${encodeURIComponent(String(watermarkId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * List watermarks
     * 
     * @param stepId Related step if any
     * @param targetId Resource linked to the watermark
     * @param type Type of watermark association
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getWatermarkList(stepId?: number, targetId?: string, type?: 'USER' | 'ORGANISATION' | 'SYSTEM', observe?: 'body', reportProgress?: boolean): Observable<Array<WatermarkData>>;
    public getWatermarkList(stepId?: number, targetId?: string, type?: 'USER' | 'ORGANISATION' | 'SYSTEM', observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<WatermarkData>>>;
    public getWatermarkList(stepId?: number, targetId?: string, type?: 'USER' | 'ORGANISATION' | 'SYSTEM', observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<WatermarkData>>>;
    public getWatermarkList(stepId?: number, targetId?: string, type?: 'USER' | 'ORGANISATION' | 'SYSTEM', observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (stepId !== undefined && stepId !== null) {
            queryParameters = queryParameters.set('stepId', <any>stepId);
        }
        if (targetId !== undefined && targetId !== null) {
            queryParameters = queryParameters.set('targetId', <any>targetId);
        }
        if (type !== undefined && type !== null) {
            queryParameters = queryParameters.set('type', <any>type);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<WatermarkData>>(`${this.basePath}/api/watermarks`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Update watermark
     * 
     * @param watermarkId Watermark id
     * @param image Image
     * @param targetId Target
     * @param type Type
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateWatermark(watermarkId: number, image?: Blob, targetId?: string, type?: 'USER' | 'ORGANISATION' | 'SYSTEM', observe?: 'body', reportProgress?: boolean): Observable<WatermarkData>;
    public updateWatermark(watermarkId: number, image?: Blob, targetId?: string, type?: 'USER' | 'ORGANISATION' | 'SYSTEM', observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<WatermarkData>>;
    public updateWatermark(watermarkId: number, image?: Blob, targetId?: string, type?: 'USER' | 'ORGANISATION' | 'SYSTEM', observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<WatermarkData>>;
    public updateWatermark(watermarkId: number, image?: Blob, targetId?: string, type?: 'USER' | 'ORGANISATION' | 'SYSTEM', observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (watermarkId === null || watermarkId === undefined) {
            throw new Error('Required parameter watermarkId was null or undefined when calling updateWatermark.');
        }




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (targetId !== undefined && targetId !== null) {
            queryParameters = queryParameters.set('targetId', <any>targetId);
        }
        if (type !== undefined && type !== null) {
            queryParameters = queryParameters.set('type', <any>type);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any; };
        let useForm = false;
        let convertFormParamsToString = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        }

        if (image !== undefined) {
            formParams = formParams.append('image', <any>image) || formParams;
        }

        return this.httpClient.put<WatermarkData>(`${this.basePath}/api/watermarks/${encodeURIComponent(String(watermarkId))}`,
            convertFormParamsToString ? formParams.toString() : formParams,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
